import React, {useEffect, useState} from 'react';
import {useAuth} from "../../authentication";
import {useSelector} from "react-redux";
import beApis from "src/util/apis/be";
import {useIntl} from "react-intl";
import IntlMessages from "../../util/IntlMessages";
import {Button, Card, Col, Flex, Input, message, Row, Space, Table, Typography} from "antd";
import {convertDateFormat, getDeviceName} from 'src/util/common';

import './index.css';
import StyledAccessModeCardItem from "../../components/StyledAccessModeCardItem";
import AccessOpen from "../../assets/svg/AccessOpen";
import AccessClose from "../../assets/svg/AccessClose";
import ToastWarn from "../../assets/svg/ToastWarn";
import ToastSuccess from "../../assets/svg/ToastSuccess";
import {SearchOutlined} from "@ant-design/icons";
import {usePopup} from "../../util/use-popup";
import AccessModePopup from "./AccessModePopup";

const {Text} = Typography;

const AccessMode = () => {
  const {authUser, userSignOut} = useAuth();
  const intl = useIntl();
  const csSelected = useSelector(({cs}) => cs.csSelected);
  const activeAgents = useSelector(({cs}) => cs.activeAgents);
  const {confirmPopup, infoPopup} = usePopup();

  const [data, setData] = useState([]);
  const [selectedAllowedDevice, setSelectedAllowedDevice] = useState(false);
  const [hostUser, setHostUser] = useState();
  const [permissionList, setPermissionList] = useState([]);
  const [selectedMode, setSelectedMode] = useState("open");
  const [accessMode, setAccessMode] = useState({});
  const [name, setName] = useState("");

  const [pageSize, setPageSize] = useState(5);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);
  const [ordering, setOrdering] = useState([]);
  const [focus, setFocus] = useState(false);

  const getFeatures = (is_open) => {
    if (is_open) {
      return [
        intl.formatMessage({id: "vlink.settings.access.open.features.all"}),
        intl.formatMessage({id: "vlink.settings.access.open.features.record"}),
        intl.formatMessage({id: "vlink.settings.access.open.features.simple"}),
      ]
    } else {
      return [
        intl.formatMessage({id: "vlink.settings.access.restricted.features.registered"}),
        intl.formatMessage({id: "vlink.settings.access.restricted.features.manual"}),
      ]
    }
  }

  const accessModeList = [
    {
      key: 'open',
      title: intl.formatMessage({id: "vlink.settings.access.open"}),
      description: intl.formatMessage({id: "vlink.settings.access.open.description"}),
      features: getFeatures(true),
      icon: <AccessOpen/>,
    },
    {
      key: 'restricted',
      title: intl.formatMessage({id: "vlink.settings.access.restricted"}),
      description: intl.formatMessage({id: "vlink.settings.access.restricted.description"}),
      features: getFeatures(false),
      icon: <AccessClose/>,
    }
  ];

  useEffect(() => {
    setFocus(true);
  }, [])

  useEffect(() => {
    const {access_mode} = authUser.settings || {};
    setSelectedMode(access_mode?.is_open ? "open" : "restricted")
  }, [authUser]);
  // useEffect(() => {
  //   if (hostUser) {
  //     setPermissionList(hostUser.product_permissions.sort())
  //   }
  // }, [hostUser])

  useEffect(() => {
    if (focus) {
      getData();
    }
  }, [focus, pageSize, current])

  const getData = () => {

    const req = {
      keyword: name,
      distinct: true,
    }

    beApis.allowedDevices(csSelected.host, req, current, pageSize).then(resp => {
      // if (name && name.length > 0) {
      //   resp.results = resp.results.filter((item) => {
      //     // name이 client 또는 location에 포함되어 있으면 true
      //     const client = item.client || "";
      //     const location = item.location || "";
      //     const ip = item.ip || "";
      //     return client.toLowerCase().includes(name.toLowerCase()) ||
      //       location.toLowerCase().includes(name.toLowerCase()) || ip.includes(name.toLowerCase());
      //   });
      // }
      setData(resp.results);
      setTotal(resp.count);
    }).catch((e) => console.log("loginHistory error", e))
  }

  const AgentStatusComponent = ({icon, text}) => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      marginRight: 16,
    }}>
      {icon}
      <span style={{margin: '0 4px'}}>
        <IntlMessages id={text}/>
      </span>
    </div>
  )

  const handleDelete = (r) => {
    confirmPopup(intl.formatMessage({id: "vlink.common.confirm.delete"}), () => {
      beApis.updateAllowedDevice(csSelected.host, r.id, {
        is_deleted: true,
      }).then((resp) => {
        message.success({
          content: intl.formatMessage({id: 'vlink.common.deleted'}),
          icon: <ToastSuccess/>,
        });
        getData();
      }).catch((e) => {
        console.log("delete error", e)
      })
    })
  }
  const handleUpdate = (r) => {

  }

// JS/TS 공용
  const withCommonOnCell = (cols, {defaultMinWidth = 120} = {}) =>
    cols.map(col => {
      const prevOnCell = col.onCell;

      return {
        ...col,
        onCell: (record, rowIndex) => {
          // 기존 onCell 결과/스타일 보존
          const prev = typeof prevOnCell === 'function' ? prevOnCell(record, rowIndex) : {};
          const prevStyle = (prev && prev.style) || {};

          // col.maxWidth: 컬럼별로 다르게 지정 (커스텀 프로퍼티)
          const cellStyle = {
            minWidth: col.minWidth ?? defaultMinWidth,
            maxWidth: col.maxWidth,            // ← 컬럼별로 다르게 줄 포인트
            ...prevStyle,
          };

          return {...prev, style: cellStyle};
        },
      };
    });
  const baseColumns = [
    {
      title: intl.formatMessage({id: 'vlink.settings.access.client'}),
      dataIndex: 'client',
      key: 'client',
      maxWidth: 170,           // 컬럼별 maxWidth 다르게
      render: (t, r) => (
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>
          {getDeviceName(r.client) || intl.formatMessage({id: 'vlink.login.device.unknown'})}
        </Text>
      ),
    },
    // {
    //   title: intl.formatMessage({id: 'vlink.settings.access.location'}),
    //   dataIndex: 'location',
    //   key: 'location',
    //   maxWidth: 190,
    //   render: (t, r) => (
    //     <Text ellipsis={{rows: 1, tooltip: true}}
    //           style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>
    //       {r.geo_data?.location || intl.formatMessage({id: 'vlink.login.device.unknown'})}
    //     </Text>
    //   ),
    // },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.ip'}),
      dataIndex: 'ip',
      key: 'ip',
      maxWidth: 130,
      render: (t, r) => (
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>
          {r.ip || intl.formatMessage({id: 'vlink.login.device.unknown'})}
        </Text>
      ),
    },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.registerTime'}),
      dataIndex: 'approved_at',
      key: 'approved_at',
      maxWidth: 130,
      render: (t, r) =>
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>{
          r.approved_at
            ? convertDateFormat(r.approved_at)
            : (r.geo_data?.connected_at ? convertDateFormat(r.geo_data.connected_at) : '')
        }</Text>
    },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.expireTime'}),
      dataIndex: 'expires_at',
      key: 'expires_at',
      maxWidth: 130,
      render: (t) =>
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>{
          t ? convertDateFormat(t) : intl.formatMessage({id: 'vlink.settings.access.unlimited'})
        }</Text>
    },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.task'}),
      key: 'task',
      // 버튼 컬럼은 maxWidth 안줄 수도 있음 (원하면 maxWidth: 180 등 지정)
      render: (t, r) => (
        <Space>
          <Button onClick={() => handleDelete(r)}><IntlMessages id="vlink.button.delete"/></Button>
          <Button onClick={() => setSelectedAllowedDevice(r)}><IntlMessages id="vlink.mobile.common.edit"/></Button>
        </Space>
      ),
    },
  ];

  const columns = withCommonOnCell(baseColumns, {defaultMinWidth: 30});

  const AccessModeSelector = ({value, onChange}) => (
    <div style={{width: "100%", margin: "0 auto"}}>
      <Row gutter={24}>
        {accessModeList.map((item) => (
          <Col key={item.key} xs={24} md={12}>
            <StyledAccessModeCardItem
              checked={value === item.key}
              onClick={() => onChange(item.key)}
              title={item.title}
              description={item.description}
              features={item.features}
              icon={item.icon}
            />
          </Col>
        ))}
      </Row>
    </div>
  );


  const onMovePage = (current) => {
    setCurrent(current);
  }

  const onChangeSize = (size) => {
    setPageSize(size);
  }

  const handleChange = (p, f, sorter) => {
    if (sorter.column) {
      const order = sorter.order === "ascend" ? sorter.column.dataIndex : "-" + sorter.column.dataIndex;
      setOrdering([order]);
    } else {
      setOrdering([]);
    }
  }
  const handleChangeAccessMode = (value) => {

    if (!authUser?.parent_id) {
      return
    }
    const {access_mode} = authUser.settings || {};
    const values = {
      settings: {
        access_mode: {
          ...access_mode,
          is_open: value === "open",
        }
      }
    }
    beApis.updateSubUser(csSelected.host, authUser.parent_id, values).then((resp) => {
      // message.config({
      //   top: '0%',  // px나 % 사용 가능
      // });
      if (value === "open") {
        message.warning({
          content: intl.formatMessage({id: 'vlink.settings.access.changedToOpen'}),
          icon: <ToastWarn/>,
        });
      } else {
        message.success({
          content: intl.formatMessage({id: 'vlink.settings.access.changedToRestricted'}),
          icon: <ToastSuccess/>,
        });
      }
    }).catch((e) => {
      console.log("에러발생", e)
    })
    setSelectedMode(value);
  }

  return (
    <div style={{display: "flex", flexDirection: "column", gap: 20, height: "100%"}}>
      <Card title={
        <Flex justify='space-between' align="center">
          <IntlMessages id="vlink.settings.access.mode"/>
          {/* <Button onClick={() => setSelectedAllowedDevice({})}><IntlMessages id="vlink.settings.account.add" /></Button> */}
        </Flex>
      } className="settings-card">
        <AccessModeSelector
          value={selectedMode}
          onChange={handleChangeAccessMode}
        />
      </Card>
      <Card title={<Flex justify='space-between' align="center">
        <div style={{display: 'flex', alignItems: 'center'}}>
          <IntlMessages id="vlink.settings.access.registeredDevices"/>
          <Text type="secondary" style={{ marginLeft: 20, fontWeight: 400, color: '#181818', fontSize: 16 }}>
            <IntlMessages id="home.totalCount" /><span style={{ margin: '0 4px', color: '#df043a' }}>{total}</span><IntlMessages id="home.countUnit" />
          </Text>
        </div>
        {/* <Button onClick={() => setSelectedAllowedDevice({})}><IntlMessages id="vlink.settings.account.add" /></Button> */}
        <Space>
          <Input value={name}
                 onChange={(e) => setName(e.target.value)}
                 style={{width: 150}}
                 onPressEnter={() => {
                   getData()
                 }}
                 prefix={<SearchOutlined/>}
                 placeholder={intl.formatMessage({id: "vlink.settings.access.searchByKeyword"})}/>
          {/*<DatePicker.RangePicker style={{ width: 280 }} onChange={(e) => { handleDatePicker(e) }} value={dateRange} allowClear />*/}
          <Button onClick={() => {
            getData()
          }} type="primary"><IntlMessages id="vlink.button.search"/></Button>
        </Space>
      </Flex>}
            className="settings-card"
      >
        <Table
          className={'user-list'}
          columns={columns}
          dataSource={data}
          pagination={{
            position: ['bottomCenter'],
            current: current,
            total: total,
            pageSize: pageSize,
            onChange(current) {
              onMovePage(current)
            },
            onShowSizeChange(current, size) {
              onChangeSize(size)
            },

          }}
          rowKey='id'
          onChange={handleChange}
          // scroll={{x: 'max-content'}}  // 핵심!
        />
      </Card>
      {selectedAllowedDevice &&
        <AccessModePopup selectedAllowedDevice={selectedAllowedDevice}
                         onOk={() => {
                           setSelectedAllowedDevice(false);
                           getData();
                         }}
                         onCancel={() => setSelectedAllowedDevice(false)}/>
      }
    </div>
  )

}

export default AccessMode;
